import { Link } from 'gatsby';
import styled from 'styled-components';

import { body } from '@constants/fonts';

export const BackBtn = styled(Link)`
  justify-self: flex-end;
  width: 46px;
  height: 46px;
  border: 1px solid ${({ theme }) => theme.palette.divider}88;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  border-radius: 50%;
  margin: ${(props) => props.theme.spacing(1)};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  position: relative;
  min-width: 46px;
  cursor: pointer;
  opacity: 0.7;
  font-family: ${body};

  &:hover {
    opacity: 1;
  }
`;
